<template>
    <div>
      <Pos_invoices_tax_add/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_add from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_add";
  export default {
    name: "PosInvoicesTaxAdd",
    components: {
      Pos_invoices_tax_add
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  